import subsComponent from "./vue_components/subs_component.vue.js";
import routes from "./routes.js";

Vue.config.devtools = true;

const router = new VueRouter({
    routes: routes,
    mode: "history",
    render: h => h(App),
    base: "/subscription/",
});

new Vue({
    el: '#subscriptionSection',
    router: router,
    data() {
        return {}
    },
    components: {
        subsComponent
    },
    mounted() {
        this.$router.afterEach((to, from) => {
            this.$emit('gs_login_signup:route_changed', {to, from});
        });
    },
    template: `
        <router-view></router-view>
    `
});
